<div class="container sms003">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage02}}</mat-label>
          </div>

          <div>
            <fieldset class="grid-frame">
              <mat-radio-group formControlName="rdoYatinYmKbn" class="radio-line" tabindex="1">
                <mat-radio-button class="grid-yatin-radio"
                                  name="rdoYatinYmKbn"
                                  *ngFor="let item of initVo; let i = index"
                                  [checked]="i === 0"
                                  [value]="item.id">
                    <div class="grid-row">
                      <mat-label class="grid-yyyymm">{{item.yatinYm}}</mat-label>
                      <mat-label class="grid-kingaku">{{item.seikyuGaku}}</mat-label>
                    </div>
                </mat-radio-button>

                <div class="grid-row grid-row-goukei">
                  <mat-label [style]="'width:28px;'">&nbsp;</mat-label>
                  <mat-label class="grid-yyyymm">{{lblGokei}}</mat-label>
                  <mat-label class="grid-kingaku">{{lblGokeiGaku}}</mat-label>
                </div>
              </mat-radio-group>
            </fieldset>
          </div>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnDetail" (click)="detailClick()" tabindex="2">{{lblBtnDetail}}</button>
          </div>

          <br>
          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage03}}</mat-label>
          </div>

          <!-- 支払日 -->
          <div  class="input-area">
            <mat-form-field appearance="standard" class="input-date-mm-field">
              <mat-label>{{lblYakusokuDateMM}}</mat-label>
              <input matInput formControlName="txtYakusokuDateMM" class="input-date-mm-text" inputmode="tel" tabindex="3" maxlength="2" min="01" max="12" />
              <mat-error *ngIf="smsForm.get('txtYakusokuDateMM')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-label>{{lblMessage04}}</mat-label>
            &nbsp;&nbsp;
            <mat-form-field appearance="standard" class="input-date-dd-field">
              <mat-label>{{lblYakusokuDateDD}}</mat-label>
              <input matInput formControlName="txtYakusokuDateDD" class="input-date-dd-text" inputmode="tel" tabindex="4" maxlength="2" min="01" max="20" />
              <mat-error *ngIf="smsForm.get('txtYakusokuDateDD')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-label>{{lblMessage05}}</mat-label>

          </div>

          <!-- 文言 -->
          <div>
            <mat-label class="message-red">{{lblMessage06}}</mat-label>
          </div>
          <div>
            <mat-label class="message-red">{{lblMessage07}}</mat-label>
          </div>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnSend" (click)="executeClick()" tabindex="5">{{lblBtnSend}}</button>
          </div>

        </div>
      </form>

    </div>

  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button [disabled]="!isEnableBtnMenu" (click)="backClick()" accesskey="q" tabindex="5">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
